import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { fetchPaymentStatus } from '@api/payment-status/payment-status.api';
import { ApiError } from '@lib/request';
import { ApiErrorType } from '@typings/common';
import { FetchPaymentStatusParamsDto } from '@api/payment-status/payment-status.dto';

export const fetchPaymentStatusAction = createAsyncThunk<
    string,
    FetchPaymentStatusParamsDto,
    { rejectValue: ApiErrorType<unknown> }
>(`FETCH_PAYMENT_STATUS`, async (payload, thunkApi) => {
    try {
        const result = await fetchPaymentStatus(payload);
        return result;
    } catch (error) {
        if (error instanceof ApiError) {
            return thunkApi.rejectWithValue(error.toJSON());
        }
        if (error instanceof Error) {
            throw new ApiError(error.message);
        }
        throw new ApiError();
    }
});

export const clearPaymentStatusAction = createAction('CLEAR_PAYMENT_STATUS');
